/** Permission checks on the /me/ effective-permissions map (spec §8.2). Code checks keys, never role names. */
export type Perms = Record<string, string>

export function can(perms: Perms | undefined, key: string): boolean {
  return perms !== undefined && Object.prototype.hasOwnProperty.call(perms, key)
}

export function canAll(perms: Perms | undefined, keys: readonly string[]): boolean {
  return keys.every((key) => can(perms, key))
}
